export function assertIsValueString(
  value: unknown,
  errorMessage = 'The value is not a string or is empty',
): asserts value is string {
  if (typeof value !== 'string') {
    throw new Error(errorMessage);
  }
}
